import { call, put, takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../../constants/ActionTypes/Dashboard';
import { ECOPROTOKEN_CLAIMS, LOCALSESSIONDATAKEYS, SUCCESS, USER_ACTIVITY_LOGS, _API_ENDPOINT, _CSAGENT_API_ENDPOINTS } from '../../constants/AppConstants';
import { _CALLPUTAPI } from '../../api/apiHandler';
import { getLocalSessionData, getUserSessionData } from '../../utils/Authentication/handleUserSession';
import i18next from 'i18next';
import { userRoles } from '../../constants/UserRoles';
import UserActivityLogsPayload from '../../utils/AdminPortal/UserActivityLogsPayload';

function _REACTIVATESUBSCRIPTION(role, userId, deviceId) {
    if (role && (role === userRoles.CSAGENT_ADMIN || role === userRoles.ADMIN)) {
        return handleSubscriptionReactivation_CSAGENT(userId, deviceId);
    } else {
        return handleSubscriptionReactivation_CUSTOMER();
    }
}

async function handleSubscriptionReactivation_CSAGENT(userId, deviceId) {
    const endpoint = _CSAGENT_API_ENDPOINTS.REACTIVATE_SUBSCRIPTION;
    const logDetails = {
        action: USER_ACTIVITY_LOGS.REACTIVATE_SUBSCRIPTION,
        description: `Reactivate subscription for the user ${userId} for the device ${deviceId}`
    }

    const payload = {
        "userId": userId,
        "deviceId": deviceId,
        servicePortalUser: await UserActivityLogsPayload(logDetails)
    }

    return _CALLPUTAPI(endpoint, payload)
        .then(response => {
            return response;
        })
        .catch((error) => {
            throw error;
        });
}

function handleSubscriptionReactivation_CUSTOMER() {
    const endpoint = _API_ENDPOINT.REACTIVATE_SUBSCRIPTION;
    const UID = getUserSessionData(ECOPROTOKEN_CLAIMS.USERID);
    const deviceId = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID);

    const payload = {
        "userId": UID,
        "deviceId": deviceId
    }

    return _CALLPUTAPI(endpoint, payload)
        .then(response => {
            return response;
        })
        .catch((error) => {
            throw error;
        });
}

function* handlesubscriptionReactivation(action) {
    try {
        const role = action.role;
        const userId = action.userId;
        const deviceId = action.deviceId;
        const subscriptionResp = yield call(_REACTIVATESUBSCRIPTION, role, userId, deviceId);
        if (subscriptionResp.actionStatus.toUpperCase() === SUCCESS) {
            yield put({ type: actionTypes.REACTIVATE_SUBSCRIPTION_SUCCESS, subscriptionResp: subscriptionResp });
        } else {
            yield put({ type: actionTypes.REACTIVATE_SUBSCRIPTION_ERROR, message: i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR") });
        }
    } catch (e) {
        /**
         * This conditional statement is added to avoid
         * displaying error message in view while logout from app
         */
        if (e instanceof TypeError === false && e.message !== "401") {
            yield put({ type: actionTypes.REACTIVATE_SUBSCRIPTION_ERROR, message: e.message });
        }
    }
}

function* ReactivateSubscription() {
    yield takeEvery(actionTypes.REACTIVATE_SUBSCRIPTION_INIT, handlesubscriptionReactivation)
}

export default ReactivateSubscription;